import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { BASE_URL } from "../http/http";
import { toast } from "react-toastify";
import { getCookie, removeCookie } from "../utils/helper";
import axios from "axios";
import Cookies from "js-cookie";

const Unsubscribe = () => {
  const navigate = useNavigate();

 const handleUnsubscribe = async () => {
  const token = localStorage.getItem('token');
  const deviceId = localStorage.getItem('deviceId');

  if (!token || !deviceId) {
    toast.error("Session expired. Please login again.");
    navigate("/login");
    return;
  }

  try {
    const response = await axios.post(
      `${BASE_URL}/api/v1/unsubscribe`,
      {
        msisdn: localStorage.getItem("msisdn"),
        currency: localStorage.getItem("currency"),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Device-Id": deviceId,
          // "X-User-Agent": navigator.userAgent // use X- instead
        }
      }
    );

    if (response.data.status === "SUCCESS") {
      toast.success(response.data.message);
      
     localStorage.removeItem('msisdn');
localStorage.removeItem('redirectUrl');
localStorage.removeItem('currency');
localStorage.removeItem('token');
localStorage.removeItem('deviceId');
      
      navigate("/login");
    }

  } catch (error) {
    toast.error("Something went wrong. Please try again.");
  }
};
  return (
    <div className="min-h-screen bg-white flex flex-col md:block">

      {/* Mobile view - completely unchanged */}
      <div className="md:hidden w-full max-w-[430px] min-h-screen bg-white flex flex-col relative mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-8 left-6 text-xl bg-transparent border-2 border-black rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-black"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        <div className="flex flex-1 items-center justify-center px-6">
          <div className="flex flex-col items-center gap-5 text-center w-full max-w-[320px]">
            <div className="text-[35px] font-black leading-none tracking-tight">
              <span className="text-black">Yo</span>
              <span className="text-[#3CB8D4]">Gamez</span>
              <span className="text-black">XR</span>
            </div>
            <h1 className="text-4xl font-bold text-black m-0">Unsubscribe</h1>
            <p className="text-xl text-gray-500 leading-relaxed m-0">
              We are sorry to see you leave. Please click the buttton below to confirm
            </p>
            <button
              onClick={handleUnsubscribe}
              className="w-full py-4 bg-[#3CB8D4] text-black border-none rounded-xl text-xl font-semibold cursor-pointer mt-2"
            >
              Unsubscribe
            </button>
            <button
              onClick={() => navigate("/profile")}
              className="w-full py-4 bg-white text-black border-2 border-gray-300 rounded-xl text-xl font-semibold cursor-pointer"
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      {/* PC view */}
      <div className="hidden md:flex min-h-screen bg-white">
        <div className="w-full flex flex-col py-12">

          {/* Back button + Title - 20% from left */}
          <div className="mb-10 pl-[20%]">
            <button
              onClick={() => navigate(-1)}
              className="text-xl bg-transparent border-2 border-black rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-black mb-6"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <h1 className="text-[42px] font-bold text-[#3CB8D4] mb-1">
              Unsubscribe
            </h1>
            <p className="text-black text-xl font-bold">
              We are sorry to see you leave. Please click the button below to confirm
            </p>
          </div>

          {/* Centered content */}
          <div className="flex flex-col items-center w-full">
            <div className="flex flex-col items-center gap-5 w-full max-w-[260px]">

              {/* Logo */}
              <div className="text-[40px] font-black leading-none tracking-tight py-4">
                <span className="text-black">Yo</span>
                <span className="text-[#3CB8D4]">Gamez</span>
                <span className="text-black">XR</span>
              </div>

              <button
                onClick={handleUnsubscribe}
                className="w-full py-4 bg-[#3CB8D4] text-black border-none rounded-xl text-base font-semibold cursor-pointer"
              >
                Unsubscribe
              </button>

              <button
                onClick={() => navigate("/profile")}
                className="w-full py-4 bg-white text-black border-2 border-gray-300 rounded-xl text-base font-semibold cursor-pointer"
              >
                Continue
              </button>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
};

export default Unsubscribe;